import React, {Component} from 'react';
import {InstantSearch, Configure} from 'react-instantsearch/dom';
import {connectAutoComplete} from 'react-instantsearch/connectors';
import search from './utils/search';
import AutoSuggest from './AutoSuggest';
import './AlgoliaSearch.less';

const AutoComplete = connectAutoComplete(AutoSuggest);

export default class AlgoliaSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
        };
        this.searchBtn = this.searchBtn.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.queryValue = this.queryValue.bind(this);
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get('search');
        this.setState({searchQuery});
    }

    queryValue(value) {
        this.setState({searchQuery: value});
    }

    handleChange(searchState) {
        this.setState({searchQuery: searchState.query});
    }

    searchBtn(e) {
        search(this.state.searchQuery);
        e.preventDefault();
        return true;
    }

    render() {
        const {apiKey, appId, index, history} = this.props;

        if (apiKey && appId) {
            return (
                <div id="algolia-search" className="careers-search-bar">
                    <InstantSearch
                        appId={appId}
                        apiKey={apiKey}
                        indexName={index}
                        onSearchStateChange={this.handleChange}
                    >
                        <div className="input-group">
                            <div className="input-group-wrapper">
                                <AutoComplete
                                    queryValue={this.queryValue}
                                    history={history}
                                />
                            </div>
                            <Configure hitsPerPage={50} />
                            <span className="input-group-btn">
                                <button
                                    onClick={this.searchBtn}
                                    className="btn btn-primary"
                                >
                                    {'Search'}
                                </button>
                            </span>
                        </div>
                    </InstantSearch>
                </div>
            );
        }

        return null;
    }
}
